export default "/images/vendor/flag-icon-css/flags/4x3/gd.svg?b446a44dff915db188691a49dd65a49e";